import styles from './Rules.module.css';

export default function Rules() {
  return (
    <div className={styles.rulesPage}>
      <div className="background" />

      <div className={styles.container}>
        <h1 className={styles.title}>Информация</h1>

        <div className={styles.rulesList}>
          <div className={styles.rule}>
            <h3>§1 Общие правила</h3>
            <ul>
              <li>Запрещён чит-клиент, X-Ray, KillAura и любые преимущества</li>
              <li>Запрещено использование <strong className={styles.ban}>ЛЮБОЙ</strong> карты</li>
              <li>Запрещён тимминг (договорённости между командами)</li>
              <li><strong>Решение админов окончательное</strong></li>
            </ul>
          </div>

          <div className={styles.rule}>
            <h3>§2 Детали геймплея</h3>
            <ul>
              <li>Версия: <strong>1.21.10</strong> (Vanilla)</li>
              <li>10 команд (макс. 3 чела в команде)</li>
              <li>PvP включено после <strong>30</strong> секунды</li>
              <li>Смерть — перманентная (вы выбываете из игры)</li>
              <li>Граница начнет сужаться через 15 минут</li>
            </ul>
          </div>

          <div className={styles.rule}>
            <h3>§3 Наказания</h3>
            <p className={styles.ban}>Нарушение = дисквалификация</p>
          </div>
        </div>
      </div>
    </div>
  );
}
